import { jsx as _jsx } from "react/jsx-runtime";
import { IRootScreenViewModelType } from './IRootScreenViewModel';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { NavigationWrapperView } from '../../Components/Navigation/NavigationWrapperView';
import { CoreScreens } from '../../Constants/CoreScreens';
import { NavigatorView } from '../../Components/Navigation/NavigatorView';
export const RootScreenComponent = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.rootScreen,
    dependencies: {
        viewModel: IRootScreenViewModelType
    }
})(({ viewModel, navigatorOptions }) => {
    return (_jsx(NavigationWrapperView, { testID: 'core', children: _jsx(NavigatorView, { navigatorOptions: navigatorOptions, screens: CoreScreens }) }));
});
